export default "__VITE_ASSET__f8094281__"